export default {
  sad69: {
    geographic: {
      epsg: '4618',
      description: 'SAD69',
      getProjection: () =>
        '+proj=longlat +ellps=aust_SA +towgs84=-57,1,-41,0,0,0,0 +no_defs',
    },
    utm: {
      epsg: '29193',
      description: 'SAD69 / UTM',
      getProjection: (zone = '23') =>
        `+proj=utm +zone=${zone} +south +ellps=aust_SA +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs`,
    },
  },
  sirgas2000: {
    geographic: {
      epsg: '4674',
      description: 'SIRGAS 2000',
      getProjection: () =>
        '+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs',
    },
    utm: {
      epsg: '31983',
      description: 'SIRGAS 2000 / UTM',
      getProjection: (zone = '23') =>
        `+proj=utm +zone=${zone} +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs`,
    },
  },
  wgs84: {
    geographic: {
      epsg: '4326',
      description: 'WGS 84',
      getProjection: () => '+proj=longlat +datum=WGS84 +no_defs',
    },
    utm: {
      epsg: '32723',
      description: 'WGS 84 / UTM',
      getProjection: (zone = '23') =>
        `+proj=utm +zone=${zone} +south +datum=WGS84 +units=m +no_defs`,
    },
  },
};
